import { useQuery } from '@tanstack/react-query';

import { useAuth } from './auth';

/**
 * An organization's teams.
 *
 * Cached under one key per organization, because a team change moves projects
 * between people and several pages have to hear about it: the organization's
 * settings, a project's settings and the team's own page.
 */
export function useTeams(orgId: string | undefined) {
  const { client } = useAuth();
  return useQuery({
    queryKey: ['teams', orgId],
    queryFn: () => client.listTeams(orgId ?? ''),
    enabled: Boolean(orgId),
  });
}
